import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BACKEND_URI;

const buildHeaders = (includeJson = false) => {
  const headers = {
    Authorization: "Bearer " + localStorage.getItem("jwt_token")
  };

  if (includeJson) {
    headers['Content-Type'] = 'application/json';
  }

  return headers;
};

export const fetchUserDetailsApi = async ({ userName, userEmail }) => {
  const response = await axios.post(
    `${BASE_URL}/api/landing_page/get_user_details`,
    {
      user_name: userName,
      user_email: userEmail
    },
    {
      headers: buildHeaders()
    }
  );

  if (response.status !== 200) {
    throw new Error(`API returned status: ${response.status}`);
  }

  const data = response.data?.data;

  if (!data) {
    throw new Error('Missing data field in response');
  }

  return data;
};

export const fetchUserSuggestionsApi = async (userName) => {
  const response = await axios.post(
    `${BASE_URL}/api/landing_page/user_name_suggestions`,
    {
      user_name: userName
    },
    {
      headers: buildHeaders(true)
    }
  );

  if (response.status !== 200) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.data;
};

export const fetchSinglePortfolioApi = async (portfolio) => {
  const response = await axios.post(
    `${BASE_URL}/api/landing_page/single_portfolio_change`,
    {
      portfolio
    },
    {
      headers: buildHeaders(true)
    }
  );

  if (response.status !== 200) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const result = response.data;

  if (!result?.data) {
    throw new Error('Missing data field in response');
  }

  return result;
};

export const fetchSinglePlatformApi = async (platform) => {
  const response = await axios.post(
    `${BASE_URL}/api/landing_page/single_platform_change`,
    {
      platform
    },
    {
      headers: buildHeaders(true)
    }
  );

  if (response.status !== 200) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const result = response.data;

  if (!result?.data) {
    throw new Error('Missing data field in response');
  }

  return {
    data: result.data,
    platform_incidents: result.platform_incidents
  };
};
